export default __webpack_public_path__ + "server.b9d405804accb4bb44fd.svg";